module.exports = __webpack_public_path__ + "static/media/12.50eaf8ae.jpeg";